export default "__VITE_ASSET__BiecPhzu__"